import { v4 as uuidv4 } from 'uuid';

export const onLoadBiocatch = (actSetBiocatchUUID) => () => {
  let finalDecision;
  const uuid = uuidv4().replace(/-/g, '');
  if (window.cdApi) {
    window.cdApi.setCustomerSessionId(uuid);
    actSetBiocatchUUID(uuid);

    window.cdApi.collectContextAmexOne = (decision) => {
      let checkDecision = decision;
      if (window.a_digitalData) {
        const eventList = window.a_digitalData.events.filter((event) => {
          if (event.type === 'journey') return event;
          return false;
        });
        const eventCount = eventList.length;
        if (eventCount > 0) {
          const lastEvent = eventList[eventCount - 1];
          const context = lastEvent.element;
          if (lastEvent.meta.appdecision && checkDecision) {
            checkDecision = false;
            finalDecision = lastEvent.meta.appdecision;
          }
          window.cdApi.changeContext(finalDecision ? `${context}:${finalDecision}` : context);
        }
      }
      setTimeout(() => {
        // If final decision exists, start new session
        if (decision && !checkDecision && window.cdApi.startNewSession !== undefined) {
          window.cdApi.startNewSession();
        }
        window.cdApi.collectContextAmexOne(checkDecision);
      }, 5e3);
    };

    window.cdApi.collectContextAmexOne(true);
  }
};

export const loadBioCatch = (locale) => {
  switch (locale) {
    case 'de-DE':
    case 'es-ES':
    case 'en-SG':
    case 'fr-FR':
    case 'it-IT':
    case 'sv-SE':
    case 'nb-NO':
      return false;
    default:
      return true;
  }
};
